/* ==============================================================
   MEYMUNI CAFE — Theme JS (global utilities)
   - Mobile hamburger drawer
   - Newsletter popup (timed)
   - Dynamic hours pill
   - Menu preview tab switching (home)
   - Hero carousel (menu/about)
   - Sticky tab bar scroll spy (menu)
   - Events tabs + modal
   - FAQ accordion
   - Catering form "Other" reveal + min date + confirm
   - PDP qty stepper
   ============================================================== */

(function () {
  'use strict';

  /* ---------- MOBILE NAV OVERLAY ---------- */
  function initHamburger() {
    var btn = document.getElementById('navToggle');
    var overlay = document.getElementById('navOverlay');
    var closeBtn = document.getElementById('navClose');
    if (!btn || !overlay) return;

    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      // next frame so the transition runs from the hidden state
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
      btn.setAttribute('aria-expanded', 'true');
      btn.setAttribute('aria-label', 'Close menu');
      document.body.classList.add('v5menu-open');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      overlay.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Open menu');
      document.body.classList.remove('v5menu-open');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var hide = function () { overlay.hidden = true; };
      if (reduce) hide();
      else window.setTimeout(hide, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-expanded') === 'true') close();
      else open();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);

    Array.prototype.forEach.call(overlay.querySelectorAll('a'), function (a) {
      a.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && btn.getAttribute('aria-expanded') === 'true') close();
    });

    // if the viewport grows past the mobile breakpoint while the overlay is open, close it
    window.addEventListener('resize', function () {
      if (window.innerWidth > 860 && btn.getAttribute('aria-expanded') === 'true') close();
    });
  }

  /* ---------- NEWSLETTER POPUP ---------- */
  function initPopup() {
    var backdrop = document.getElementById('popupBackdrop');
    if (!backdrop) return;
    var closeBtn = document.getElementById('popupClose');
    var delay = parseInt(backdrop.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 5000;

    function open() { backdrop.classList.add('open'); }
    function close() { backdrop.classList.remove('open'); }

    try {
      if (!sessionStorage.getItem('meymuniPopupShown')) {
        setTimeout(function () {
          open();
          sessionStorage.setItem('meymuniPopupShown', '1');
        }, delay);
      }
    } catch (e) {
      setTimeout(open, delay);
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) close();
    });
  }

  /* ---------- SHOP POPUP (15% off, shop/product pages only) ---------- */
  function initShopPopup() {
    var backdrop = document.getElementById('shopPopupBackdrop');
    if (!backdrop) return;
    var closeBtn = document.getElementById('shopPopupClose');
    var delay = parseInt(backdrop.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 5000;

    function open() { backdrop.classList.add('open'); }
    function close() { backdrop.classList.remove('open'); }

    try {
      if (!sessionStorage.getItem('meymuniShopPopupShown')) {
        setTimeout(function () {
          open();
          sessionStorage.setItem('meymuniShopPopupShown', '1');
        }, delay);
      }
    } catch (e) {
      setTimeout(open, delay);
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) close();
    });
  }

  /* ---------- DYNAMIC HOURS PILL ---------- */
  function initHours() {
    var pill = document.getElementById('hoursPill');
    var txt = document.getElementById('hoursText');
    if (!pill || !txt) return;

    var now = new Date();
    var day = now.getDay();
    var mins = now.getHours() * 60 + now.getMinutes();
    var sched = {
      0: { open: 600, close: 1080, label: '10am–6p' },
      1: null,
      2: { open: 600, close: 1020, label: '10am–5p' },
      3: { open: 600, close: 1020, label: '10am–5p' },
      4: { open: 600, close: 1020, label: '10am–5p' },
      5: { open: 600, close: 1020, label: '10am–5p' },
      6: { open: 600, close: 1080, label: '10am–6p' }
    };
    var names = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    function nextOpenDay() {
      for (var i = 1; i <= 7; i++) {
        var d = (day + i) % 7;
        if (sched[d]) return { d: d, s: sched[d] };
      }
      return null;
    }
    var today = sched[day];
    if (!today) {
      pill.classList.add('closed');
      var nxt = nextOpenDay();
      txt.textContent = 'closed today · back ' + names[nxt.d] + ' ' + nxt.s.label;
    } else if (mins < today.open) {
      pill.classList.add('closed');
      txt.textContent = 'opens today · ' + today.label;
    } else if (mins >= today.close) {
      pill.classList.add('closed');
      var nxt2 = nextOpenDay();
      txt.textContent = 'closed now · back ' + names[nxt2.d] + ' ' + nxt2.s.label;
    } else {
      pill.classList.remove('closed');
      txt.textContent = 'open today · ' + today.label;
    }
  }

  /* ---------- HOME MENU TAB SWITCHER ---------- */
  function initMenuTabs() {
    var wrap = document.getElementById('menuTabs');
    if (!wrap) return;
    var groups = document.querySelectorAll('[data-menu-group]');
    Array.prototype.forEach.call(wrap.querySelectorAll('.menu-tab'), function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab');
        Array.prototype.forEach.call(wrap.querySelectorAll('.menu-tab'), function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        Array.prototype.forEach.call(groups, function (g) {
          g.style.display = g.getAttribute('data-menu-group') === target ? '' : 'none';
        });
      });
    });
    Array.prototype.forEach.call(groups, function (g, i) {
      g.style.display = i === 0 ? '' : 'none';
    });
  }

  /* ---------- HERO IMAGE CAROUSEL (Menu + About) ---------- */
  function initHeroCarousel() {
    var roots = document.querySelectorAll('[data-hero-carousel]');
    Array.prototype.forEach.call(roots, function (root) {
      var slides = root.querySelectorAll('.hero-slide');
      var dots = root.querySelectorAll('.hero-dots button, .slide-dots button');
      if (slides.length < 2) return;
      var i = 0;
      function go(n) {
        i = (n + slides.length) % slides.length;
        Array.prototype.forEach.call(slides, function (s, k) {
          s.classList.toggle('active', k === i);
          s.classList.toggle('on', k === i);
        });
        Array.prototype.forEach.call(dots, function (d, k) { d.classList.toggle('on', k === i); });
      }
      Array.prototype.forEach.call(dots, function (d) {
        d.addEventListener('click', function () {
          var n = parseInt(d.getAttribute('data-i'), 10) || 0;
          go(n); reset();
        });
      });
      var timer = null;
      function reset() {
        clearInterval(timer);
        timer = setInterval(function () { go(i + 1); }, 4500);
      }
      reset();
    });
  }

  /* ---------- MENU PAGE TAB BAR SCROLL SPY ---------- */
  function initMenuScrollSpy() {
    var inner = document.getElementById('tabBarInner');
    if (!inner) return;
    var tabs = inner.querySelectorAll('a');
    var cards = document.querySelectorAll('.cat-card[id]');
    function onScroll() {
      var active = null;
      var topPad = 200;
      Array.prototype.forEach.call(cards, function (c) {
        var r = c.getBoundingClientRect();
        if (r.top - topPad <= 0) active = c.id.replace('cat-', '');
      });
      Array.prototype.forEach.call(tabs, function (t) {
        t.classList.toggle('active', t.getAttribute('data-slug') === active);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- EVENTS TABS + MODAL ---------- */
  function initEventsTabs() {
    var btns = document.querySelectorAll('.event-tabs .tab-btn');
    if (!btns.length) return;
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function () {
        var pane = btn.getAttribute('data-pane');
        Array.prototype.forEach.call(btns, function (b) {
          b.classList.toggle('on', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        Array.prototype.forEach.call(document.querySelectorAll('.events-pane'), function (p) {
          p.classList.toggle('on', p.id === 'pane-' + pane);
          p.style.display = p.id === 'pane-' + pane ? '' : 'none';
        });
      });
    });
  }

  function initEventModal() {
    var backdrop = document.getElementById('eventModal');
    if (!backdrop) return;
    var closeBtn = document.getElementById('eventModalClose');

    function close() { backdrop.classList.remove('open'); }
    function open(data) {
      document.getElementById('modalName').textContent = data.name || '';
      document.getElementById('modalDate').textContent = data.date || '';
      document.getElementById('modalTime').textContent = data.time || '';
      document.getElementById('modalLoc').textContent = data.location || '';
      document.getElementById('modalDesc').textContent = data.desc || '';
      var rsvp = document.getElementById('modalRsvp');
      if (rsvp) {
        if (data.rsvp) { rsvp.style.display = ''; rsvp.href = data.rsvp; }
        else { rsvp.style.display = 'none'; }
      }
      var art = document.getElementById('modalArt');
      if (art) {
        art.innerHTML = '';
        if (data.image) {
          var img = document.createElement('img');
          img.src = data.image;
          img.alt = data.name || '';
          art.appendChild(img);
        }
      }
      backdrop.classList.add('open');
    }

    Array.prototype.forEach.call(document.querySelectorAll('.event-card.upcoming'), function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        var data = {
          name: card.getAttribute('data-name'),
          date: card.getAttribute('data-date'),
          time: card.getAttribute('data-time'),
          location: card.getAttribute('data-location'),
          desc: card.getAttribute('data-desc'),
          rsvp: card.getAttribute('data-rsvp'),
          image: card.getAttribute('data-image')
        };
        open(data);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- FAQ ACCORDION ---------- */
  function initFaq() {
    Array.prototype.forEach.call(document.querySelectorAll('.accordion .acc-q'), function (q) {
      q.addEventListener('click', function () {
        var item = q.parentElement;
        item.classList.toggle('open');
      });
    });

    var pills = document.querySelectorAll('.cat-pill');
    Array.prototype.forEach.call(pills, function (p) {
      p.addEventListener('click', function (e) {
        e.preventDefault();
        var target = p.getAttribute('data-target');
        var el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        Array.prototype.forEach.call(pills, function (x) { x.classList.toggle('on', x === p); });
      });
    });
  }

  /* ---------- CATERING FORM ---------- */
  function initCateringForm() {
    var typeSel = document.getElementById('fType');
    var otherField = document.getElementById('otherField');
    if (typeSel && otherField) {
      var otherInput = document.getElementById('fOther');
      typeSel.addEventListener('change', function () {
        var isOther = typeSel.value === 'Other';
        otherField.classList.toggle('show', isOther);
        if (otherInput) {
          otherInput.required = isOther;
          if (!isOther) otherInput.value = '';
        }
      });
    }
    var dateInput = document.getElementById('fDate');
    if (dateInput) {
      var d = new Date();
      var pad = function (n) { return String(n).padStart(2, '0'); };
      dateInput.min = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    }
  }

  /* ---------- PDP QTY STEPPER ---------- */
  function initQtyStepper() {
    var qi = document.getElementById('qtyInput');
    if (!qi) return;
    var minus = document.getElementById('qtyMinus');
    var plus = document.getElementById('qtyPlus');
    if (minus) minus.addEventListener('click', function () { qi.value = Math.max(1, (+qi.value || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { qi.value = (+qi.value || 1) + 1; });
  }

  /* ---------- QUICK ADD TO CART (collection grid) ---------- */
  function initQuickAdd() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-quick-add]'), function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        var original = btn.textContent;
        btn.textContent = 'Adding…';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.textContent = 'Added ✓';
            // refresh cart badge
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              var badge = document.getElementById('cartBadge');
              if (badge) {
                badge.textContent = cart.item_count;
                badge.style.display = cart.item_count > 0 ? '' : 'none';
              }
            });
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1400);
          })
          .catch(function () {
            btn.textContent = 'Try again';
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
          });
      });
    });
  }

  /* ---------- INIT ALL ---------- */
  function init() {
    initHamburger();
    initPopup();
    initShopPopup();
    initHours();
    initMenuTabs();
    initHeroCarousel();
    initMenuScrollSpy();
    initEventsTabs();
    initEventModal();
    initFaq();
    initCateringForm();
    initQtyStepper();
    initQuickAdd();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
